export default __webpack_public_path__ + "static/sithamshu-manoj-bik_lIl9Nco-unsplash-b326a9101ac082f84cf7adab6bc18d5b.jpg";